// extracted by mini-css-extract-plugin
module.exports = {"trxnBannerContainer":"List_trxnBannerContainer__2xg0e","link":"List_link__1zf6W"};